import { jsxs, jsx } from "react/jsx-runtime";
import { cva } from "@/styled-system/css";
import { Slider } from "@zillow/constellation-10";
import { event } from "@zillow/universal-analytics";
import { debounce } from "lodash";
import React from "react";
import { useFormContext } from "react-hook-form";
import { getWholeDollars, getCommaSeparatedNumber } from "../../../utils/zhl-calculator.esm.js";
import { useLastValidAffordabilityValues, AFFORDABILITY_DTI_MAX, FieldConfig } from "../AffordabilityCalculator.utils.esm.js";
import { trackLabel } from "../trackLabel.esm.js";
import AffordabilityDescription from "./AffordabilityDescription.esm.js";
import AffordabilityGraphic from "./AffordabilityGraphic.esm.js";
const handleFieldChange = debounce((label) => {
  const cmsInfo = {
    block_type_cd: "slider",
    block_id: "afffordability_calc",
    block_displayed_txt: label
  };
  sendInteractionEvent(cmsInfo);
}, 3e3);
const sendInteractionEvent = (cmsInfo) => {
  const newLaneData = {
    envelope: {
      event_type_id: "2056",
      event_type_version_id: "2",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_slider",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_engagement"
    },
    cms_info: cmsInfo
  };
  event(newLaneData);
};
const activeTrackStyles = cva({
  base: {},
  variants: {
    aggressive: {
      true: {
        backgroundColor: "bg.accent.blue.hero"
      },
      false: {
        backgroundColor: "bg.accent.green.hero"
      }
    }
  }
});
const debouncedTrackSliderEdit = debounce(() => trackLabel("Slider Edit"), 1e3);
function AffordabilityVisual() {
  const form = useFormContext();
  const lastValidValues = useLastValidAffordabilityValues(form);
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    /* @__PURE__ */ jsx(AffordabilityDescription, { aggressive: lastValidValues.calculations.aggressive, affordabilityByDTI: lastValidValues.calculations.affordability.affordabilityByDTI }),
    /* @__PURE__ */ jsx(AffordabilityGraphic, { customPayment: lastValidValues.fields.customPayment, monthlyPayment: lastValidValues.fields.monthlyPayment, maximumPayment: lastValidValues.fields.maximumPayment, dti: lastValidValues.fields.dti }),
    /* @__PURE__ */ jsxs(Slider.Root, { id: "affordability-slider", reverse: true, min: 0, tooltipPlacement: "bottom", tooltipText: `${getWholeDollars(lastValidValues.calculations.affordability.monthlyPayment)}/mo`, max: lastValidValues.fields.customPayment ? lastValidValues.fields.maximumPayment : AFFORDABILITY_DTI_MAX, value: [
      // Invert value for reversed slider
      (lastValidValues.fields.customPayment ? lastValidValues.fields.maximumPayment : AFFORDABILITY_DTI_MAX) - (lastValidValues.fields.customPayment ? lastValidValues.fields.monthlyPayment : lastValidValues.fields.dti)
    ], onValueChange: (values) => {
      const sliderValue = values[0];
      const max = lastValidValues.fields.customPayment ? lastValidValues.fields.maximumPayment : AFFORDABILITY_DTI_MAX;
      const actualValue = max - sliderValue;
      form.setValue(lastValidValues.fields.customPayment ? FieldConfig.monthlyPayment.name : FieldConfig.dti.name, getCommaSeparatedNumber(actualValue), {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true
      });
      debouncedTrackSliderEdit();
      handleFieldChange("Affordability slider");
    }, children: [
      /* @__PURE__ */ jsx(Slider.Track, { children: /* @__PURE__ */ jsx(Slider.ActiveTrack, { className: activeTrackStyles({
        aggressive: lastValidValues.calculations.aggressive
      }) }) }),
      /* @__PURE__ */ jsx(Slider.Handle, {})
    ] })
  ] });
}
export {
  AffordabilityVisual as default
};
